var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.intersected)?_c('div',[_vm._t("default")],2):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }